var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_269_5110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5110)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.7283 7.43035C14.3475 7.42998 13.9824 7.27854 13.7131 7.00928C13.4439 6.74002 13.2924 6.37492 13.292 5.99413V4H6.87503C6.62884 3.99991 6.38502 4.04832 6.15754 4.14247C5.93005 4.23663 5.72334 4.37467 5.54922 4.54873C5.3751 4.72279 5.23698 4.92945 5.14274 5.15689C5.0485 5.38434 5 5.62813 5 5.87433V17.1732C5 17.4195 5.0485 17.6632 5.14274 17.8906C5.23698 18.1181 5.3751 18.3248 5.54922 18.4988C5.72334 18.6729 5.93005 18.811 6.15754 18.9051C6.38502 18.9992 6.62884 19.0476 6.87503 19.0476H14.5785C15.0756 19.0476 15.5524 18.8501 15.9038 18.4986C16.2554 18.1471 16.4528 17.6703 16.4528 17.1732V7.43035H14.7283Z",
    fill: "#EF9A9A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5023 7.48699H14.7778C14.397 7.48662 14.0319 7.33518 13.7626 7.06592C13.4934 6.79666 13.3419 6.43156 13.3416 6.05077V4.05664L16.5023 7.48699Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8613 15.9399H9.15206C8.53427 15.9399 8.03345 16.4407 8.03345 17.0585V19.6552C8.03345 20.273 8.53427 20.7738 9.15206 20.7738H17.8613C18.4791 20.7738 18.9799 20.273 18.9799 19.6552V17.0585C18.9799 16.4407 18.4791 15.9399 17.8613 15.9399Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6564 18.9004V19.4054H10.134V18.9004H10.6564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5307 17.5088C12.7068 17.6517 12.8265 17.8523 12.8685 18.0751H12.3343C12.2984 17.9827 12.2352 17.9035 12.1532 17.848C12.067 17.7915 11.9657 17.7626 11.8627 17.7651C11.7947 17.763 11.7271 17.7765 11.6651 17.8046C11.6032 17.8328 11.5485 17.8748 11.5054 17.9274C11.417 18.0545 11.3696 18.2055 11.3696 18.3603C11.3696 18.5151 11.417 18.6661 11.5054 18.7932C11.5487 18.8455 11.6035 18.8872 11.6654 18.9151C11.7273 18.9429 11.7948 18.9563 11.8627 18.9541C11.9657 18.9566 12.067 18.9277 12.1532 18.8712C12.2347 18.8164 12.2979 18.7382 12.3343 18.6469H12.8685C12.8255 18.869 12.706 19.0689 12.5307 19.2118C12.3421 19.3565 12.1087 19.4305 11.8711 19.4207C11.6844 19.4248 11.5 19.3784 11.3375 19.2863C11.1851 19.1981 11.0616 19.0675 10.9823 18.9102C10.8998 18.7382 10.8569 18.5497 10.8569 18.3589C10.8569 18.1681 10.8998 17.9796 10.9823 17.8076C11.0616 17.6503 11.1851 17.5197 11.3375 17.4315C11.5 17.3394 11.6844 17.293 11.8711 17.2971C12.1089 17.2884 12.3423 17.3633 12.5307 17.5088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.566 19.1223C14.5062 19.2183 14.4201 19.2951 14.318 19.3438C14.1942 19.4019 14.0584 19.43 13.9217 19.426C13.7155 19.4343 13.5122 19.3743 13.3436 19.2553C13.269 19.1994 13.208 19.1274 13.1651 19.0447C13.1221 18.962 13.0984 18.8707 13.0956 18.7775H13.6327C13.6362 18.8476 13.666 18.9137 13.7162 18.9628C13.7662 19.0094 13.8325 19.0344 13.9008 19.0324C13.9568 19.0353 14.0118 19.0163 14.054 18.9795C14.0726 18.9614 14.0872 18.9398 14.097 18.9158C14.1066 18.8918 14.1113 18.866 14.1105 18.8402C14.1112 18.8157 14.1068 18.7914 14.0979 18.7686C14.0889 18.7459 14.0754 18.7253 14.0582 18.7078C14.0218 18.6705 13.9782 18.6409 13.9301 18.6208C13.8792 18.5978 13.8082 18.5713 13.7211 18.5393C13.6108 18.5029 13.503 18.4592 13.3986 18.4083C13.3126 18.3638 13.2387 18.2991 13.1834 18.2196C13.1234 18.122 13.0921 18.0096 13.0928 17.8951C13.0936 17.7806 13.1264 17.6686 13.1876 17.5718C13.2531 17.4788 13.3437 17.4063 13.4488 17.3629C13.5699 17.3137 13.6998 17.2899 13.8305 17.2932C14.0283 17.2826 14.2238 17.341 14.3835 17.4583C14.4507 17.5129 14.5059 17.5807 14.5456 17.6577C14.5853 17.7347 14.6086 17.819 14.614 17.9055H14.0687C14.0624 17.8441 14.0359 17.7865 13.9935 17.7418C13.9716 17.7212 13.9459 17.7053 13.9177 17.6948C13.8897 17.6844 13.8597 17.6798 13.8298 17.6812C13.7791 17.6796 13.7296 17.6964 13.6905 17.7285C13.6714 17.7461 13.6565 17.7678 13.647 17.7919C13.6375 17.816 13.6335 17.842 13.6354 17.8678C13.6345 17.9144 13.6521 17.9595 13.6842 17.9932C13.7188 18.0294 13.7606 18.0581 13.8068 18.0775C13.8562 18.0991 13.9266 18.1269 14.0157 18.1604C14.1281 18.1966 14.2375 18.2413 14.3431 18.2941C14.43 18.3406 14.5047 18.4069 14.5611 18.4877C14.6262 18.5851 14.6585 18.7009 14.6531 18.8179C14.6529 18.9255 14.6228 19.0309 14.566 19.1223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3196 17.3203L15.8294 18.8896L16.34 17.3203H16.8798L16.154 19.4057H15.5021L14.7798 17.3203H15.3196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5223 13.3791H9.47774C9.21417 13.3791 9 13.1167 9 12.7938V10.5848C9 10.2623 9.21417 10 9.47774 10H12.5223C12.7858 10 13 10.2623 13 10.5848V12.7926C13 13.1155 12.7858 13.3791 12.5223 13.3791ZM9.47774 10.3005C9.34907 10.3005 9.24448 10.4283 9.24448 10.5861V12.7938C9.24448 12.9515 9.34907 13.0798 9.47774 13.0798H12.5223C12.6509 13.0798 12.7559 12.9515 12.7559 12.7938V10.5848C12.7559 10.4271 12.6509 10.2993 12.5223 10.2993L9.47774 10.3005Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.878 12.0483H9.12207V12.3476H12.878V12.0483Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.878 11.022H9.12207V11.3212H12.878V11.022Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9162 10.1494H11.6169V13.228H11.9162V10.1494Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.383 10.1494H10.0837V13.228H10.383V10.1494Z",
    fill: "#EF9A9A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_269_5110",
    x: -4,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_269_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_269_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16.7861,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.1da4bc3d52ea4a9f34e614c4e11dfd9d.svg";
export { ForwardRef as ReactComponent };